// Lazily fills in the bound-integration list for whichever version is selected.
// The backend keeps it off the catalog payload to keep that response small, and
// assignments change out-of-band, so this refetches on every selection rather
// than caching.

import { useEffect } from 'react';

import ActionsApi from '../../api/actions';

export default function useActionIntegrations({
  action,
  version,
  refreshKey,
  setActions,
}) {
  useEffect(() => {
    if (!action || !version) return undefined;

    let cancelled = false;
    (async () => {
      const response = await ActionsApi.fetchActionIntegrations(version.uuid);
      if (cancelled || !response.data) return;

      const integrationNames = response.data.map((row) => row.attributes.name);
      // Side-channel name → uuid lookup so the IntegrationsTab can build a
      // /integrations/:uuid link without re-fetching. `integrations` stays a
      // plain string[] because the Migrate/Delete/Lock flows treat it that way.
      const integrationIdByName = Object.fromEntries(
        response.data.map((row) => [row.attributes.name, row.id]),
      );

      setActions((cur) =>
        cur.map((a) =>
          a.id !== action.id
            ? a
            : {
                ...a,
                versions: a.versions.map((v) =>
                  v.version === version.version
                    ? {
                        ...v,
                        integrations: integrationNames,
                        integrationIdByName,
                      }
                    : v,
                ),
              },
        ),
      );
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action?.id, version?.uuid, refreshKey]);
}
